import {
  useQuery,
  type QueryClient,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getFavoritePairings,
  getFavoritePairingsPath,
  type GetFavoritePairingsParams,
} from '@hungryroot/rest/api/v2/customers/[id]/favorite_pairings/get/get-api-v2-customers-customer_id-favorite_pairings';

type OptionType = Pick<UseQueryOptions, 'enabled'>;

export function invalidateFavoritePairings(
  client: QueryClient,
  queryParams: GetFavoritePairingsParams
) {
  // we also need to invalidate all the query keys for the query to populates the list of pairings
  // so the views are in sync
  client.invalidateQueries({
    queryKey: [getFavoritePairingsPath(queryParams)],
  });
}

export function useFavoritePairings(
  queryParams: GetFavoritePairingsParams,
  options?: OptionType
) {
  return useQuery({
    queryKey: [getFavoritePairingsPath(queryParams)],
    queryFn: async () => {
      const resp = await getFavoritePairings(queryParams);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
